import * as constants from './constants';

const storyDetailsReducer = (
  state = {
    fetching: false,
    success: false,
    story: null,
    pointsOfInterest: null,
    errors: null
  },
  action
) => {
  switch (action.type) {
    case constants.STORY_DETAILS_LAUNCHED:
      state = {
        ...state,
        fetching: true,
        success: false,
        story: null,
        pointsOfInterest: null,
        errors: null
      };
      break;
    case constants.STORY_DETAILS_SUCCESS:
      state = {
        ...state,
        fetching: false,
        success: true,
        story: action.story,
        pointsOfInterest: action.pointsOfInterest,
        errors: null
      };
      break;
    case constants.STORY_DETAILS_FAILURE:
      state = {
        ...state,
        fetching: false,
        success: false,
        story: null,
        pointsOfInterest: null,
        errors: action.errors
      };
      break;
    default:
      break;
  }
  return state;
};

export default storyDetailsReducer;
